import { axiosClient } from "@/shared/api/axios-client";
import type { SolicitudResumen, TipoSolicitud } from "@/lib/types";

/**
 * Endpoints del bootstrap de una nueva solicitud · tres pasos:
 *   1. POST /solicitudes (vacía, estado Iniciada)
 *   2. PATCH /tipo (FB60, único soportado en el MVP)
 *   3. PATCH /subtipo (CFDI_UNICO o MULTIPLES_CFDI)
 *
 * Se exponen por separado · el hook los encadena.
 */
export const nuevaSolicitudApi = {
  iniciar: () =>
    axiosClient.post<SolicitudResumen>("/api/solicitudes").then((r) => r.data),

  asignarTipo: (id: string, tipo: TipoSolicitud) =>
    axiosClient
      .patch<SolicitudResumen>(`/api/solicitudes/${id}/tipo`, { tipo })
      .then((r) => r.data),

  asignarSubtipo: (id: string, subtipo: string) =>
    axiosClient
      .patch<SolicitudResumen>(`/api/solicitudes/${id}/subtipo`, { subtipo })
      .then((r) => r.data),
};
